var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalRecordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.82,
    height: 25.408,
    viewBox: "0 0 25.82 25.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MedicalRecordIcon",
    transform: "translate(-517.027 -105.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2815",
    "data-name": "Group 2815"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1246",
    "data-name": "Rectangle 1246",
    width: 6.365,
    height: 22.348,
    transform: "translate(517.527 108.483)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M521.811,111.841a1.112,1.112,0,1,0-1.112,1.112A1.108,1.108,0,0,0,521.811,111.841Z",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_941",
    "data-name": "Line 941",
    x2: 3.872,
    transform: "translate(518.784 123.231)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_942",
    "data-name": "Line 942",
    x2: 3.872,
    transform: "translate(518.784 125.373)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M520.473,128.463h.453l-.227-.866h-.02Zm.576.412h-.679l-.144.6h-.557l.763-2.719h.535l.762,2.719h-.556Z",
    fill: "#344154"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 6.365,
    height: 22.348,
    transform: "translate(526.755 106.423)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M531.039,109.781a1.112,1.112,0,1,0-1.112,1.112A1.108,1.108,0,0,0,531.039,109.781Z",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_943",
    "data-name": "Line 943",
    x2: 3.872,
    transform: "translate(528.011 121.171)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_944",
    "data-name": "Line 944",
    x2: 3.872,
    transform: "translate(528.011 123.313)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M529.577,126.218v.8h.391a.355.355,0,0,0,.268-.1.407.407,0,0,0,.082-.288.505.505,0,0,0-.082-.31.344.344,0,0,0-.247-.1h-.412Zm0-.371h.267a.392.392,0,0,0,.268-.1.349.349,0,0,0,.083-.268.41.41,0,0,0-.1-.288.4.4,0,0,0-.289-.083h-.247v.742Zm-.536,1.565v-2.719h.783a1.043,1.043,0,0,1,.659.186.649.649,0,0,1,.247.556.686.686,0,0,1-.082.35.655.655,0,0,1-.247.226.491.491,0,0,1,.329.227.663.663,0,0,1,.1.392.792.792,0,0,1-.226.6.992.992,0,0,1-.639.206h-.927Z",
    fill: "#344154"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1248",
    "data-name": "Rectangle 1248",
    width: 6.365,
    height: 22.348,
    transform: "translate(535.982 108.483)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M539.175,110.728a1.112,1.112,0,0,1,.425,2.14,1.112,1.112,0,1,1-.851-2.055A1.09,1.09,0,0,1,539.175,110.728Z",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_945",
    "data-name": "Line 945",
    x2: 3.852,
    transform: "translate(537.239 123.231)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_946",
    "data-name": "Line 946",
    x2: 3.852,
    transform: "translate(537.239 125.373)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M540.081,128.627a.806.806,0,0,1-.226.659.911.911,0,0,1-.659.227.934.934,0,0,1-.7-.268,1.017,1.017,0,0,1-.268-.741v-.8a1.072,1.072,0,0,1,.248-.741.929.929,0,0,1,.679-.268.965.965,0,0,1,.68.226.833.833,0,0,1,.227.66v.02h-.495a.614.614,0,0,0-.082-.37.426.426,0,0,0-.309-.1.31.31,0,0,0-.288.144.834.834,0,0,0-.1.432v.8a.734.734,0,0,0,.1.432.359.359,0,0,0,.329.144.408.408,0,0,0,.289-.1.547.547,0,0,0,.082-.37h.494Z",
    fill: "#344154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M520.753,111a.823.823,0,1,1-.583.241A.793.793,0,0,1,520.753,111Z",
    fill: "#ffc124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M530.021,108.936a.825.825,0,1,1-.582.241A.8.8,0,0,1,530.021,108.936Z",
    fill: "#ffc124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M539.084,111a.825.825,0,1,1-.582.241A.793.793,0,0,1,539.084,111Z",
    fill: "#ffc124"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecordIcon);
export default __webpack_public_path__ + "static/media/MedicalRecordIcon.31604b62cdbbccb415fca9fee3df2310.svg";
export { ForwardRef as ReactComponent };